import React, { Component, PropTypes } from 'react';
import { Modal} from 'react-bootstrap';

class Spinner extends Component {
    render() {
        return (
            <div>
                <Modal show={this.props.show} backdrop="static">
                    <div className="modal-body">
                        Loading Champions. Please wait...
                        <div className="text-center"></div>
                    </div>
                </Modal>
            </div>
        );
    }
}


export default Spinner;